/* eslint-disable */

export default {
	common: {
		'1': '一月',
		'2': '二月',
		'3': '三月',
		'4': '四月',
		'5': '五月',
		'6': '六月',
		'7': '七月',
		'8': '八月',
		'9': '九月',
		'10': '十月',
		'11': '十一月',
		'12': '十二月',
		adults: '大人',
		children: '小孩',
		bookNow: '立即订房',
		prev: '上一则',
		backToHome: '回列表页',
		next: '下一则',
		detail: '详细资讯',
		selectDate: '选择日期',
		selectHotel: '选择分馆',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即订房',
	},
	pageTitle: {
		brandName: 'Just Sleep 捷丝旅',
		main: '品牌首页',
		news: '最新优惠 ',
		privacy: '隐私声明与 Cookie 政策',
		accommodation: '房型介绍',
		facility: '设施服务',
		restaurant: '餐厅会议',
		location: '交通景点',
		activity: '馆内活动',
	},
	header: {
		main: '品牌首页',
		news: '最新优惠 ',
		index: '分馆首页',
		accommodation: '房型介绍',
		facility: '设施服务',
		restaurant: '餐厅会议',
		location: '交通景点',
		activity: '馆内活动',
		bookNow: '立即订房',
		taiwan: '台湾',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即订房',
	},
	footer: {
		registrationNumber: '旅馆业登记证编号',
		privacy: '隐私声明与 Cookie 政策',
	},
	cookieBar: {
		attention:
			'<p>我们重视且尊重您的隐私。</p> \n<p>晶华国际酒店集团的全球官方网站是使用独立的第三方Cookie来提升网站的表现、分析数据以及达到更精准的投放广告。若您浏览此网站，即代表您同意我们使用第三方Cookie。若欲了解更多相关信息，建议您可前往我们的{{privacyLink}}进行查看。</p>',
		privacy: '"隐私声明与Cookie政策网页" ',
		accept: '同意，并浏览网站',
	},
	homePage: {
		title: '风格优旅 心细如缕',
		about: '关于',
		aboutJustsleep: '关于捷丝旅',
		toHotelSite: '前往官网',
		more: '了解更多',
		justNews: '最新消息',
		justComfortTitle: 'Just 好眠',
		justComfortBackTitle: 'Just 好眠',
		justComfortContent:
			'饭店内提供不同的枕头选择，使毎一位下榻捷丝旅的旅人，皆可获得舒适的睡眠品质。',
		justGoTitle: 'Just 好游',
		justGoBackTitle: 'Just 好游',
		justGoContent: '饭店内提供旅游咨询服务，依据每一位旅人的需求推荐景点、购物好店及交通信息。',
		justEquipTitle: 'Just 备品',
		justEquipBackTitle: 'Just 备品',
		justEquipContent:
			'提供自拍神器、手机充电器、行动电源、台灯等特殊备品（限台北西门馆、及台大尊贤馆）。',
		justBuyTitle: 'Just 好买',
		justBuyBackTitle: 'Just 好买',
		justBuyContent: '提供代购台湾特色伴手礼之服务，为旅人省下时间、轻松旅游。',
		justPackTitle: 'Just 打包',
		justPackBackTitle: 'Just 打包',
		justPackContent: '提供行李秤重及各尺寸纸箱选购之服务，由专人帮您免费打包、轻松返程。',
		justRelax: '便捷设施',
		justSight: '景點介绍',
		justGo: 'Just 好游',
		justExplore: '捷丝旅·探索',
		justService: '贴心服务',
	},
	accommodationPage: {
		rooms: '房型介绍',
		roomFacilityTitle: '客房设施 • 备品',
		lookupRoomType: '查看客房类型',
		have: '共有',
		roomType: '房型',
		am: '上午',
		pm: '下午',
		checkInTime: '入住时间',
		checkOutTime: '退房时间',
		detail: '详细资讯',
		bookNow: '立即订房',
	},
	locationPage: {
		location: '交通景点',
		trainInfo: '台铁/高鐵资讯',
		busInfo: '客运资讯',
		driveInfo: '开车资讯',
		parkInfo: '停车资讯',
		hotelInfo: '饭店接驳',
		airplaneInfo: '机场资讯',
	},
	newsHomePage: {
		all: '全部',
		news: '最新优惠 ',
		selectType: '选择类型',
		more: '了解更多',
	},
	newsPage: {
		projectTime: '专案期间',
		projectDetail: '专案内容',
		note: '备注',
	},
	restaurantPage: {
		restaurantsAndMeetings: '餐厅会议',
		restaurant: '餐厅',
		meeting: '会议',
	},
	activityPage: {
		activity: '馆内活动',
		attractionsNearby: '推荐景点',
		more: '了解更多',
		lookupSchedule: '查看行程',
		join: '立刻報名',
	},
	facilityPage: {
		facility: '设施服务',
		lookup: '查看簡介',
	},
	justFunSection: {
		justFun: '西门十趣',
	},
	hotelMain: {
		name: '品牌首頁',
		title: '',
		longName: '品牌首頁',
		bannerText: '捷丝旅',
		contactUs: '客服信箱',
		address: '台北市罗斯福路四段83号',
		intro:
			'「Just Sleep 捷丝旅」为晶华国际酒店集团旗下之设计型旅馆品牌，秉持「风格优旅，心细如缕」的品牌精神，使旅人可以亲民、实惠的价格，享受媲美五星饭店的优质服务。\n',
	},
	hotelXimen: {
		name: '台北西门馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中正区中华路一段41号5楼（请由汉口街一段144号出入）',
		intro:
			'「捷丝旅台北西门馆」邻近繁华、热闹的西门町商圈，旅人可轻松畅游台北市最具历史故事的景点，体验台味新潮文化之余，亦可品尝地道美食。\n',
	},
	hotelNTU: {
		name: '台大尊贤馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市大安区罗斯福路四段83号',
		intro:
			'「捷丝旅台大尊贤馆」位于国立台湾大学旁，提供至校园教学、实习、研究、学术交流、会议及参访人员舒适旅宿的选择，馆内将自在的学院风格融入设计中，营造与校园共荣的氛围。\n',
	},
	hotelZhongshan: {
		name: '台北中山馆',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中山区中山北路一段135巷39号',
		intro:
			'捷丝旅台北中山馆位于融合了历史底蕴与现代活力的中山区，临近台北地铁（捷运）中山站，交通极为便利。旅客可轻松步行探索繁华的条通及中山商圈，感受老城区的复古情调与现代时尚的交织。这里是海内外旅客深度体验台北“Citywalk”和轻旅行的理想下榻之选。',
	},
	hotelKaohsiung: {
		name: '高雄中正馆',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市苓雅区中正一路134号',
		intro:
			'「捷丝旅高雄中正馆」以音乐风格为设计主轴，内部空间设计兼具时尚音乐风格与实用功能。本馆临近高雄捷运苓雅运动园区站(旧名:技击馆站)、卫武营国家艺术文化中心及武庙夜市，将提供旅人不同凡响的旅宿体验。\n',
	},
	hotelKaohsiungStation: {
		name: '高雄站前馆',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市新兴区中山一路280号',
		intro:
			'「捷丝旅高雄站前馆」以视觉艺术为主轴，将美学融入饭店设计中，兼具精品魅力及文创的时尚气息。临近高雄火车站、捷运美丽岛站及六合夜市，都能便利前往不同的景点，为旅客休憩的首选。',
	},
	hotelHualien: {
		name: '花莲中正馆',
		title: '',
		contactUs: '客服信箱',
		address: '花莲市中正路396号',
		intro:
			'拥有五星级饭店血统的设计旅店捷丝旅，以平实的价格提供顾客超乎想象的优质服务，馆内设有儿童游戏室以及图书馆，让旅客在其中能够得到放松，并补给心灵的能量，提供与众不同的住宿新享受。',
	},
	hotelJiaoxi: {
		name: '宜兰礁溪馆',
		title: '',
		contactUs: '客服信箱',
		address: '宜兰县礁溪乡德阳路24巷8号',
		intro:
			'「捷丝旅宜兰礁溪馆」邻近热闹的礁溪商圈，全馆提供碳酸氢钠温泉，是礁溪地区设计旅店的全新指标，旅人步行即可至著名观光景点如五峰旗风景区、汤围沟温泉公园等。\n',
	},
	hotelSanchong: {
		name: '台北三重馆',
		title: '',
		contactUs: '客服信箱',
		address: '新北市三重区三和路四段107-1号（捷运三和国中站2号出口往后走1分钟）',
		intro:
			'「捷丝旅台北三重馆」拥有绝佳的地理位置，捷运三和国中站就在门口，交通四通八达；商务住宿或是旅游休憩均十分方便。全新的轻工业风建筑，透过手工烘培的咖啡与台湾原片茶，传达给每一位旅人在舒适的客房休息之余，还有温润贴心的服务与感受。',
	},
	hotelHushan: {
		name: '台南虎山馆',
		title: '',
		contactUs: '客服信箱',
		address: '台南市仁德区文华路二段300号',
		intro:
			'「捷丝旅台南虎山馆」紧邻十鼓仁糖文创园区、奇美博物馆，让旅人探索文艺景点享尽地利之便。邻近高铁站、机场、高速公路等交通要点，是商务活动及亲子度假的饭店首选。',
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心斋桥馆',
		title: '',
		contactUs: '客服信箱',
		address: '542-0081大阪市中央区南船场二丁目9-15',
		intro:
			'「捷丝旅大阪心斋桥馆」是捷丝旅品牌进军日本的首家据点，饭店位置紧邻热闹繁华的心斋桥商圈，商圈内美食店铺林立，房客步行即可沉浸式的体验在地潮流文化与热情好客的风土民情。\n饭店对外交通四通八达，心斋桥站、本町站、堺筋本町及长堀桥站等四大地铁车站近在咫尺，出行时便利性十足，绝对是旅人规划大阪自由行时的住宿首选。',
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889',
	},
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/resources/zh-CN.js